import type { MessageKey } from './en';

export const hi: Partial<Record<MessageKey, string>> = {
  'app.name': 'मेंडीकोट',
  'app.tagline': 'दहलों का क्लासिक भारतीय खेल',

  'common.cancel': 'रद्द करें',
  'common.close': 'बंद करें',
  'common.back': 'वापस',
  'common.continue': 'आगे बढ़ें',
  'common.loading': 'लोड हो रहा है…',
  'common.save': 'सेव करें',
  'common.or': 'या',
  'common.edit': 'बदलें',
  'common.more': 'और तरीके',
  'common.beta': 'बीटा',

  'home.greeting': 'नमस्ते, {{name}}',
  'home.playFriends': 'दोस्तों के साथ खेलें',
  'home.playFriendsDesc': 'प्राइवेट टेबल · कोड से बुलाएँ',
  'home.practice': 'बॉट्स के साथ अभ्यास',
  'home.practiceDesc': 'ऑफ़लाइन · अपनी रफ़्तार से',
  'home.join': 'कोड से जुड़ें',
  'home.howTo': 'कैसे खेलें',
  'home.continueGame': 'अपनी टेबल पर लौटें',
  'home.onlineUnavailable': 'ऑनलाइन खेल के लिए Firebase प्रोजेक्ट चाहिए — अभ्यास अभी खेलें।',

  'create.title': 'टेबल सेट करें',
  'create.practiceTitle': 'अभ्यास टेबल',
  'create.players': 'खिलाड़ी',
  'create.trump': 'हुकुम',
  'create.trump.CUT': 'कट (काटे)',
  'create.trump.CUT.desc':
    'जो खिलाड़ी सबसे पहले चाल का रंग नहीं दे पाता, उसका पत्ता हुकुम तय करता है।',
  'create.trump.BAND_A_AUTO': 'बंद हुकुम',
  'create.trump.BAND_A_AUTO.desc':
    'बाँटने वाले के दाएँ बैठा खिलाड़ी एक पत्ता छिपाता है। पहली बार कोई रंग न दे पाए, तब वह हुकुम खुलता है।',
  'create.trump.BAND_B_REQUEST': 'बंद · माँगने पर',
  'create.trump.RANDOM_OPEN': 'खुला हुकुम',
  'create.trump.RANDOM_OPEN.desc': 'बाँटने से पहले एक हुकुम का रंग खोल दिया जाता है।',
  'create.trump.BAND_B_REQUEST.desc':
    'बंद जैसा, पर रंग न दे पाने वाला खिलाड़ी तय करता है कि हुकुम खोले या नहीं।',
  'create.target': 'मैच की लंबाई',
  'create.targetValue': 'पहले {{n}} तक',
  'create.timer': 'चाल का टाइमर',
  'create.timerValue': '{{n}} से.',
  'create.timerOff': 'बंद',
  'create.difficulty': 'बॉट का स्तर',
  'create.create': 'टेबल बनाएँ',
  'create.deal': 'पत्ते बाँटें',
  'create.name': 'आपका नाम',

  'difficulty.easy': 'आसान',
  'difficulty.normal': 'तेज़',

  'join.title': 'टेबल से जुड़ें',
  'join.code': 'रूम कोड',
  'join.submit': 'सीट लें',
  'join.invalid': '6 अक्षरों का कोड डालें',

  'lobby.title': 'टेबल {{code}}',
  'lobby.share': 'दोस्तों को बुलाएँ',
  'lobby.copy': 'लिंक कॉपी करें',
  'lobby.copied': 'लिंक कॉपी हो गया',
  'lobby.shareShort': 'शेयर',
  'lobby.partners': 'टीमें बारी-बारी से बैठती हैं — आपका साथी सामने बैठता है।',
  'lobby.shareText': 'मेरी मेंडीकोट टेबल पर आओ! कोड {{code}}',
  'lobby.waiting': 'खिलाड़ियों का इंतज़ार…',
  'lobby.ready': 'मैं तैयार हूँ',
  'lobby.notReady': 'तैयार नहीं',
  'lobby.isReady': 'तैयार',
  'lobby.start': 'मैच शुरू करें',
  'lobby.addBot': 'बॉट जोड़ें',
  'lobby.removeBot': 'बॉट हटाएँ',
  'lobby.emptySeat': 'खाली सीट',
  'lobby.takeSeat': 'यहाँ बैठें',
  'lobby.host': 'होस्ट',
  'lobby.you': 'आप',
  'lobby.team': 'टीम {{team}}',
  'lobby.rules': 'टेबल के नियम',
  'lobby.leave': 'टेबल छोड़ें',
  'lobby.needAll': 'शुरू करने के लिए सभी सीटें भरें और सब तैयार हों।',
  'lobby.hostWillStart': 'होस्ट मैच शुरू करेगा।',

  'table.yourTurn': 'आपकी बारी',
  'table.waitingFor': '{{name}} सोच रहे हैं…',
  'table.reserveTitle': 'हुकुम का पत्ता छिपाएँ',
  'table.reserveHint': 'एक पत्ता चुनें। कोई रंग न दे पाए, तब उसका रंग हुकुम बनेगा।',
  'table.reserveWaiting': '{{name}} हुकुम छिपा रहे हैं…',
  'table.trump': 'हुकुम',
  'table.trumpHidden': 'छिपा',
  'table.trumpNone': 'तय नहीं',
  'table.tens': 'दहले',
  'table.tricks': 'हाथ',
  'table.led': 'चाल',
  'table.hand': 'बाज़ी {{n}}',
  'table.score': 'बाज़ियाँ',
  'table.revealRequest': 'हुकुम खोलें',
  'table.nudge': 'याद दिलाएँ',
  'table.nudged': 'याद दिलाया',
  'table.bot': 'बॉट',
  'table.away': 'दूर',
  'table.you': 'आप',
  'table.partner': 'साथी',
  'table.dealer': 'बाँटने वाला',
  'table.hiddenTrump': 'आपका छिपा हुकुम',
  'table.menu': 'मेन्यू',
  'table.lastTrick': 'पिछला हाथ',
  'table.leave': 'मैच छोड़ें',

  'illegal.MUST_FOLLOW_SUIT': '{{suit}} दें',
  'illegal.NOT_YOUR_TURN': 'अपनी बारी का इंतज़ार करें',
  'illegal.CARD_RESERVED': 'आपका छिपा हुकुम',
  'illegal.MUST_PLAY_TRUMP': 'हुकुम चलें',
  'illegal.default': 'अभी यह पत्ता नहीं चल सकते',

  'event.trumpSet': '{{name}} ने काटा — {{suit}} हुकुम है!',
  'event.trumpRevealed': 'हुकुम खुला: {{suit}}',
  'event.autoPlayed': 'समय ख़त्म — {{name}} के लिए पत्ता चला गया',
  'event.botTakeover': '{{name}} की सीट बॉट संभाल रहा है',
  'event.playerReturned': '{{name}} वापस आ गए',
  'event.trickWon': '{{name}} ने हाथ जीता',

  'result.win': 'आपकी टीम ने बाज़ी जीती!',
  'result.loss': 'यह बाज़ी दूसरी टीम की',
  'result.draw': 'बराबरी — फिर से बाँटें',
  'result.coat': 'मेंडीकोट!',
  'result.coatDesc': 'चारों दहले जीते',
  'result.whitewash': 'वाइटवॉश!',
  'result.whitewashDesc': 'हर एक हाथ',
  'result.tens': 'दहले',
  'result.tricks': 'हाथ',
  'result.next': 'अगली बाज़ी',
  'result.seeMatch': 'मैच का नतीजा देखें',
  'result.nextIn': 'अगली बाज़ी {{n}} से. में',
  'result.nextDealer': 'अगली बार {{name}} बाँटेंगे',
  'result.waiting': 'दूसरों का इंतज़ार…',

  'match.won': 'मैच जीत गए!',
  'match.lost': 'मैच हार गए',
  'match.final': 'अंतिम स्कोर {{a}} – {{b}}',
  'match.rematch': 'फिर से खेलें',
  'match.backToLobby': 'लॉबी में लौटें',
  'match.home': 'होम',
  'match.playAgain': 'दोबारा खेलें',

  'suit.S': 'काला पान',
  'suit.H': 'पान',
  'suit.D': 'ईंट',
  'suit.C': 'चिड़ी',
  'team.us': 'हम',
  'team.them': 'वे',

  'auth.title': 'अपनी प्रगति सेव करें',
  'auth.subtitle': 'हर डिवाइस पर अपने आँकड़े और सीट रखें।',
  'auth.google': 'Google से जारी रखें',
  'auth.email': 'ईमेल',
  'auth.password': 'पासवर्ड',
  'auth.displayName': 'नाम',
  'auth.signIn': 'साइन इन',
  'auth.signUp': 'खाता बनाएँ',
  'auth.switchToSignUp': 'नए हैं? खाता बनाएँ',
  'auth.switchToSignIn': 'खाता है? साइन इन करें',
  'auth.signOut': 'साइन आउट',
  'auth.forgot': 'पासवर्ड भूल गए?',
  'auth.resetSent': 'पासवर्ड रीसेट ईमेल भेजा गया',
  'auth.openInBrowser': 'इस ऐप में Google साइन-इन बंद है। पेज को ब्राउज़र में खोलें।',
  'auth.guestNote': 'आप मेहमान के रूप में खेल रहे हैं',

  'settings.title': 'सेटिंग्स',
  'settings.gameplay': 'खेल',
  'settings.themeAuto': 'त्योहार के हिसाब से',
  'settings.sound': 'आवाज़',
  'settings.haptics': 'वाइब्रेशन',
  'settings.reducedMotion': 'कम एनिमेशन',
  'settings.fourColor': 'चार रंग का पत्ता',
  'settings.language': 'भाषा',
  'settings.notifications': 'सूचनाएँ',
  'settings.notificationsDesc': 'बारी और टेबल की याद',
  'settings.analytics': 'उपयोग डेटा साझा करें',
  'settings.account': 'खाता',
  'settings.deleteAccount': 'खाता हटाएँ',
  'settings.deleteConfirm': 'क्या आप अपना खाता और आँकड़े हमेशा के लिए हटाना चाहते हैं?',
  'settings.theme': 'त्योहार थीम',

  'profile.title': 'प्रोफ़ाइल',
  'profile.games': 'मैच',
  'profile.wins': 'जीत',
  'profile.coats': 'मेंडीकोट',
  'profile.whitewashes': 'वाइटवॉश',

  'push.title': 'अपनी बारी कभी न चूकें',
  'push.body': 'आपकी बारी या टेबल तैयार होने पर सूचना पाएँ।',
  'push.enable': 'चालू करें',
  'push.later': 'अभी नहीं',
  'push.iosHint': 'iPhone पर सूचनाओं के लिए मेंडीकोट को होम स्क्रीन पर जोड़ें।',

  'pwa.install': 'ऐप इंस्टॉल करें',
  'pwa.installDesc': 'फ़ुल-स्क्रीन खेल और ऑफ़लाइन अभ्यास।',

  'connection.offline': 'आप ऑफ़लाइन हैं',
  'connection.reconnecting': 'फिर से जुड़ रहे हैं…',

  'error.ROOM_FULL': 'यह टेबल भरी है',
  'error.NO_SUCH_CODE': 'इस कोड की कोई टेबल नहीं',
  'error.ROOM_IN_PROGRESS': 'यह मैच शुरू हो चुका है',
  'error.ROOM_CLOSED': 'यह टेबल बंद हो गई',
  'error.NOT_HOST': 'यह सिर्फ़ होस्ट कर सकता है',
  'error.NETWORK': 'कनेक्शन में दिक्कत — फिर कोशिश करें',
  'error.default': 'कुछ गड़बड़ हुई',

  'theme.default': 'शाही',
  'theme.diwali': 'दिवाली',
  'theme.holi': 'होली',
  'theme.navratri': 'नवरात्रि',
  'theme.durga_puja': 'दुर्गा पूजा',
  'theme.ganesh_chaturthi': 'गणेश चतुर्थी',
  'theme.onam': 'ओणम',
  'theme.pongal_sankranti': 'पोंगल और संक्रांति',
  'theme.raksha_bandhan': 'रक्षा बंधन',
  'theme.independence_day': 'स्वतंत्रता दिवस',
  'theme.republic_day': 'गणतंत्र दिवस',
  'theme.eid': 'ईद',
  'theme.christmas_newyear': 'क्रिसमस और नया साल',

  'greeting.default': 'चार साथी जुटाएँ। दहले जीतें।',
  'greeting.diwali': 'शुभ दीपावली! टेबल जगमगाएँ।',
  'greeting.holi': 'होली मुबारक! रंगों के साथ खेलें।',
  'greeting.navratri': 'शुभ नवरात्रि!',
  'greeting.ganesh_chaturthi': 'गणपति बाप्पा मोरया!',
  'greeting.raksha_bandhan': 'रक्षा बंधन की शुभकामनाएँ!',
  'greeting.independence_day': 'स्वतंत्रता दिवस की शुभकामनाएँ! जय हिंद।',
  'greeting.republic_day': 'गणतंत्र दिवस की शुभकामनाएँ!',
  'greeting.eid': 'ईद मुबारक!',

  'howto.title': 'कैसे खेलें',
  'howto.goal.title': 'दहले जीतें',
  'howto.goal.body':
    'चार खिलाड़ी, दो टीमें। साथी आमने-सामने बैठते हैं। जो टीम चार में से ज़्यादा दहले जीतती है, वह बाज़ी जीतती है — चारों दहले यानी मेंडीकोट!',
  'howto.play.title': 'रंग दें',
  'howto.play.body':
    'बाँटने वाले के दाएँ वाला खिलाड़ी चाल चलता है। हो सके तो सबको वही रंग देना होता है। सबसे बड़ा पत्ता जीतता है — जब तक हुकुम न चले।',
  'howto.cut.title': 'काटने से हुकुम',
  'howto.cut.body':
    'कट मोड में जो पहला खिलाड़ी रंग नहीं दे पाता, वह कोई भी पत्ता चलता है — और उसका रंग पूरी बाज़ी के लिए हुकुम बन जाता है।',
  'howto.band.title': 'बंद हुकुम',
  'howto.band.body':
    'बंद मोड में खेल से पहले एक हुकुम पत्ता छिपाया जाता है। पहली बार कोई रंग न दे पाए, तब वह खुलता है।',
  'howto.score.title': 'जीत',
  'howto.score.body':
    'ज़्यादा दहले वाली टीम जीतती है। दो-दो दहले हों तो ज़्यादा हाथ वाली टीम जीतती है। सभी 13 हाथ जीतना वाइटवॉश है।',
  'howto.start': 'अभ्यास खेल शुरू करें',

  'settings.privacy': 'गोपनीयता और डेटा',
  'settings.downloadData': 'मेरा डेटा डाउनलोड करें',
  'settings.downloadDone': 'आपकी डेटा फ़ाइल डाउनलोड हो रही है',
  'settings.privacyPolicy': 'गोपनीयता नीति',
  'gate.title': 'खेलने से पहले',
  'gate.age': 'मेंडीकोट 18 वर्ष और उससे अधिक उम्र के खिलाड़ियों के लिए है।',
  'gate.noticeIntro': 'हम क्या उपयोग करते हैं, और क्यों:',
  'gate.item.game':
    'एक गेस्ट आईडी, आपका उपनाम, अवतार और आपके गेम — आपकी टेबल चलाने और आपके आँकड़े रखने के लिए।',
  'gate.item.account':
    'आपका ईमेल या Google नाम — केवल तभी जब आप अपनी प्रगति सहेजने के लिए साइन इन करें।',
  'gate.item.push': 'एक नोटिफ़िकेशन टोकन — केवल तभी जब आप रिमाइंडर चालू करें।',
  'gate.item.security': 'Google reCAPTCHA द्वारा सुरक्षा जाँच — बॉट्स को दूर रखने के लिए।',
  'gate.item.analytics':
    'उपयोग, परफ़ॉर्मेंस और क्रैश डेटा, एक रैंडम आईडी से जुड़ा, आपका नाम या ईमेल कभी नहीं — केवल आपकी अनुमति से।',
  'gate.rights': 'सेटिंग्स में कभी भी अपना डेटा डाउनलोड करें या हटाएँ, और अपनी पसंद बदलें।',
  'gate.policy': 'गोपनीयता नीति',
  'gate.playShare': 'मैं 18+ हूँ · उपयोग डेटा की अनुमति दें',
  'gate.playNoShare': 'मैं 18+ हूँ · साझा न करें',
  'gate.under18': 'मेरी उम्र 18 से कम है',
  'gate.blockedTitle': 'क्षमा करें, आपकी उम्र 18 होनी चाहिए',
  'gate.blockedBody': 'मेंडीकोट केवल 18 वर्ष और उससे अधिक उम्र के खिलाड़ियों के लिए है।',
  'gate.blockedBack': 'मुझसे गलती हुई',
  'privacy.title': 'गोपनीयता नीति',
  'privacy.languageNote':
    'यह नीति अंग्रेज़ी में है। हिंदी, गुजराती, मराठी या किसी अन्य भारतीय भाषा में प्रति के लिए हमें ईमेल करें।',
};
